<template>
  <div class="excel-export-container">
    <el-page-header content="业务汇总表导出" />
    <el-card class="export-card" shadow="hover">
      <div class="query-section">
        <el-form :inline="true" class="export-query-form">
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-download"
              @click="exportSummaryExcel"
              :loading="isExporting"
            >
              导出业务汇总表
            </el-button>
          </el-form-item>
        </el-form>
        <div class="export-tip">
          <i class="el-icon-info"></i>
          温馨提示：汇总表将整合7张基础表的核心业务数据，导出格式为.xlsx，数据实时从数据库查询，导出过程请耐心等待。<br/>
          <span style="color:#f56c6c;font-size:12px;">若未自动下载，请检查浏览器是否拦截了下载弹窗</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import service from '@/utils/request'

export default {
  name: 'ExcelExport',
  data() {
    return {
      isExporting: false
    }
  },
  methods: {
    async exportSummaryExcel() {
      this.isExporting = true
      try {
        // 核心简化：仅保留3个必要配置，其余由全局封装统一处理
        const response = await service.get(
          'excel/export/summary',
          {
            timeout: 600000,        // 10分钟超时
            responseType: 'blob',   // 强制二进制流接收
            headers: {
              // 仅指定接收Excel流，其余头由全局封装处理
              'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
          }
        )

        // 显式指定Blob为Excel类型，确保解析无乱码
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        })

        // 过滤空文件，避免无效处理
        if (blob.size < 100) {
          this.$message.error('汇总表导出失败：后端返回空文件，无有效数据');
          return;
        }

        // 生成秒级时间戳文件名，避免重名
        const now = new Date()
        const timeStr = now.getFullYear() + 
          (now.getMonth() + 1).toString().padStart(2, '0') + 
          now.getDate().toString().padStart(2, '0') + 
          now.getHours().toString().padStart(2, '0') + 
          now.getMinutes().toString().padStart(2, '0') + 
          now.getSeconds().toString().padStart(2, '0')
        const fileName = `业务汇总表_${timeStr}.xlsx`

        // 强制触发下载：a标签+window.open双兜底，避免拦截
        const downloadUrl = window.URL.createObjectURL(blob)
        // 主方案：a标签标准鼠标事件触发
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = fileName
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }))
        // 延迟清理资源，确保下载完成
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(downloadUrl)
        }, 2000)

        // 兜底方案：window.open强制下载
        setTimeout(() => {
          if (document.querySelector(`a[href="${downloadUrl}"]`) === null) {
            window.open(downloadUrl, '_blank')
          }
        }, 1000)

        this.$message.success('汇总表导出成功！若未自动下载，请检查浏览器下载弹窗拦截～')

      } catch (error) {
        // 精准分类提示，定位真实错误原因
        console.error('Excel导出真实错误信息：', error);
        if (error.response) {
          this.$message.error(`汇总表导出失败：接口返回${error.response.status}错误（${error.response.statusText}）`);
        } else if (error.request) {
          this.$message.error('汇总表导出失败：网络不通，未收到后端响应，请检查网络');
        } else if (error.message.includes('config')) {
          this.$message.error('汇总表导出失败：请求配置异常，请检查全局request封装');
        } else {
          this.$message.error(`汇总表导出失败：${error.message || '未知错误'}`);
        }
      } finally {
        this.isExporting = false
      }
    }
  }
}
</script>

<style scoped>
.excel-export-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 120px);
}
.export-card {
  padding: 30px;
}
.query-section {
  margin-bottom: 20px;
}
.export-query-form {
  margin-bottom: 15px;
}
.export-tip {
  padding: 10px 15px;
  background-color: #e6f7ff;
  border-radius: 6px;
  color: #1890ff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.6;
}
.export-tip .el-icon-info {
  margin-right: 8px;
  font-size: 16px;
  vertical-align: middle;
}
</style>